/** Şeffaf arka planlı marka ikonu (2000×2000 PNG) */
export const BRAND_LOGO_SRC = '/assets/park-mesaj-logo-nobg.png';
